import { createSelector } from 'reselect'
import { featureStateSelector } from './featureStateSelector'

export const isLoadingListOverviewCsvReportSelector = createSelector(
  featureStateSelector,
  state => state.UIState.list.isLoadingCsv
)

export default isLoadingListOverviewCsvReportSelector
